/**
 * Formatting Utilities
 * 
 * Helper functions for formatting data (dates, URLs, etc.)
 * NOTE: Behavior copied from legacy App.js, do not change without regression testing.
 * 
 * @file formatters.js
 * @description Contains utility functions for data formatting
 */

import { BACKEND_URL } from './constants';

/**
 * Helper function to get full image URL
 * Handles data URLs, full URLs, and relative paths
 * 
 * @param {string|null} logoUrl - The logo URL (can be data URL, full URL, or relative path)
 * @returns {string|null} Full image URL or null if no URL provided
 */
export const getImageUrl = (logoUrl) => {
  if (!logoUrl) return null;
  // If it's already a data URL or full URL, return as-is
  if (logoUrl.startsWith('data:') || logoUrl.startsWith('http')) return logoUrl;
  // Otherwise construct full URL
  return `${BACKEND_URL}${logoUrl}`;
};

/**
 * Helper function to format date as MonDD (e.g., Dec15, Jan05)
 * Used throughout the app for displaying dates in a compact format
 * 
 * @param {string} dateString - ISO date string or Date-compatible string
 * @returns {string} Formatted date string (MonDD) or 'N/A' if invalid
 */
export const formatMonDD = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    // Parse date string to avoid timezone conversion issues
    // If date is in YYYY-MM-DD format, parse it directly
    let date;
    if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [year, month, day] = dateString.split('-').map(Number);
      date = new Date(year, month - 1, day); // month is 0-indexed
    } else {
      date = new Date(dateString);
    }
    
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}${day}`;
  } catch (e) {
    return 'N/A';
  }
};
